var eiMessageTypePrefix = 'ENROLLMENT';
var EI_IFRAME_ID = 'CMTX_EM';
var EIMessageTypes;
(function (EIMessageTypes) {
    EIMessageTypes["ACCESS_TOKEN"] = "accessToken";
    EIMessageTypes["INIT"] = "init";
})(EIMessageTypes || (EIMessageTypes = {}));
/**
 * Console logs a message
 *
 * @param message
 */
var logMessaging = function (message) {
    // eslint-disable-next-line no-console
    console.debug("[" + eiMessageTypePrefix + "] " + message);
};
var eiSendIFrameMessage = function (message) {
    var _a;
    var frame = document.getElementById(EI_IFRAME_ID);
    (_a = frame === null || frame === void 0 ? void 0 : frame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, '*');
    // eslint-disable-next-line no-console
    if (!frame)
        console.warn('[IFRAME_NOT_FOUND] Enrollment messages are not sending.');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var eiSendMessage = function (type, payload) {
    eiSendIFrameMessage({ type: eiMessageTypePrefix + "." + type, payload: payload });
};
var eiSendInitMessage = function () {
    window.parent.postMessage({ type: eiMessageTypePrefix + "." + EIMessageTypes.INIT }, '*');
};
var eiGetMessageListener = function (_a) {
    var accessToken = _a.accessToken, _b = _a.enableLogging, enableLogging = _b === void 0 ? false : _b, onAccessToken = _a.onAccessToken, onInitialized = _a.onInitialized;
    return function (ev) {
        var _a, _b, _c;
        if (!((_a = ev.data) === null || _a === void 0 ? void 0 : _a.type))
            return;
        if (((_c = ((_b = ev.data.type) !== null && _b !== void 0 ? _b : '')) === null || _c === void 0 ? void 0 : _c.indexOf(eiMessageTypePrefix)) !== 0)
            return;
        var type = ev.data.type.replace(eiMessageTypePrefix + ".", '');
        if (enableLogging)
            logMessaging("[" + type + "] RECEIVED");
        switch (type) {
            case EIMessageTypes.ACCESS_TOKEN:
                onAccessToken && onAccessToken(ev.data.payload);
                break;
            case EIMessageTypes.INIT:
                if (!accessToken) {
                    if (enableLogging)
                        logMessaging("[" + EIMessageTypes.INIT + "] Access Token requested and token is missing.");
                    return;
                }
                eiSendMessage(EIMessageTypes.ACCESS_TOKEN, accessToken);
                onInitialized && onInitialized();
                break;
        }
    };
};

export { EIMessageTypes, EI_IFRAME_ID, eiGetMessageListener, eiSendIFrameMessage, eiSendInitMessage, eiSendMessage };
